






































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { vuex } from "@/store";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
// interfaces
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { ExBundleVM } from "@/interfaces/ExBundleAssignmentGroupVM";

//const auth = namespace("auth");
// const globals = namespace("globals");
const globals = namespace("globals");


@Component({
  components: {
    TusFileDrop
  }
})
export default class BundleImportDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;

  @globals.Getter selectedBundle: any;
  busy = false;
  archiveLog = "";


  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      console.log("open dialog");
      this.archiveLog = "";

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async onBundleArchiveFileUploaded(response: any) {
    if (!response.success) {
      this.$store.commit("ux/SB_FAILURE", {
        message: response.message,
        timeout: 0
      });
      return;
    }
    this.busy = true;

    let params = <ParamDictionary>{dictionary: {}};
    params.dictionary!["FileName"] = response.fileName;

    await rest.url("contentManager/importExerciseExcelOrZipArchiveFile").post(params) // importExerciseExcelOrZipArchiveFile
    .then(async (response) => {
      console.log("onBundleArchiveFileUploaded response", response);
      if (!response) {
        vuex.globals.setBundle(null);
        this.$emit('finished:bundleImportDlg');
        return;
      }

      // vuex.globals.setBundle(<ExBundleVM> { guid: response });

      this.archiveLog += "<br<br>" + response;

      this.$emit('finished:bundleImportDlg');
    })
    .catch(err => {
    })
    .finally(() => {
      this.busy = false;
    });
  }

  onCancel() {
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
  }
}
